import { apiFetch } from './apiClient';

export interface TeamMember {
  uid: string;
  displayName: string;
  email: string;
}

/** Membri del team Arcanum per il selettore "proprietario lead" (GET /arcanum-team, riservato al team). */
export async function listTeamMembers(): Promise<TeamMember[]> {
  const rows = await apiFetch<Array<{ uid: string; displayName: string; email: string }>>('/arcanum-team');
  return rows.map((r) => ({ uid: r.uid, displayName: r.displayName || r.email || r.uid, email: r.email || '' }));
}
